import apiClient from '../client';
import type { Event, CreateEventPayload, UpdateEventPayload } from '@/types';

export interface BulkUploadResult {
  inserted_count: number;
  error_count: number;
  inserted: Event[];
  errors: Array<{ row: number; message: string }>;
}

export const eventsApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: Event[]; pagination: { total: number } }>('/admin/events', { params }).then((r) => r.data),

  getById: (id: number) =>
    apiClient.get<{ data: Event }>(`/admin/events/${id}`).then((r) => r.data.data),

  create: (payload: CreateEventPayload) =>
    apiClient.post<{ data: Event }>('/admin/events', payload).then((r) => r.data.data),

  update: (id: number, payload: UpdateEventPayload) =>
    apiClient.put<{ data: Event }>(`/admin/events/${id}`, payload).then((r) => r.data.data),

  remove: (id: number) =>
    apiClient.delete(`/admin/events/${id}`),

  publish: (id: number, is_published: boolean) =>
    apiClient.patch<{ data: Event }>(`/admin/events/${id}/publish`, { is_published }).then((r) => r.data.data),

  /**
   * Download the CSV template file.
   * Triggers a browser download by creating a temporary <a> element.
   */
  downloadTemplate: async () => {
    const response = await apiClient.get('/admin/events/template', { responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'events_template.csv');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  /**
   * Upload a CSV file for bulk event creation.
   * Returns per-row insertion results and validation errors.
   */
  bulkUpload: (file: File) => {
    const form = new FormData();
    form.append('file', file);
    return apiClient
      .post<{ success: boolean; data: BulkUploadResult }>('/admin/events/bulk', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data.data);
  },
};

